import api from '../../../api/client'

export async function fetchAuditLogFilters() {
  const { data } = await api.get('/audit-logs/filters')
  return data || {}
}

export async function fetchAuditLogList(params = {}) {
  const { data } = await api.get('/audit-logs/list', { params })
  return data || {}
}

export async function exportAuditLogList(params = {}) {
  const response = await api.get('/audit-logs/export', {
    params,
    responseType: 'blob',
  })
  const contentDisposition = response.headers?.['content-disposition'] || ''
  const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/i)
  const filename = filenameMatch?.[1] || 'audit-logs-export.csv'
  return { blob: response.data, filename }
}
